import { Component, OnInit } from '@angular/core';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { PromotionsService } from '../../promotions.service';

@Component({
  selector: 'app-send-promo-smart',
  template: `<app-send-promo [productTypes]="productTypes" [countries]="countries"></app-send-promo>`,
  styles: [
  ]
})
export class SendPromoSmartComponent extends FeaturesBaseComponent implements OnInit {
  productTypes: any;
  countries: any;
  constructor(private promotionService: PromotionsService) {
    super();
    this.getData()
  }
  getData() {
    this.promotionService.getcodeGroups().subscribe(
      res => {
        this.productTypes = res['data'];
      }
    )

    this.promotionService.getCarrierCountries().subscribe(
      res => {
        this.countries = res['data']
      }
    )
  }

  ngOnInit(): void {
    super.ngOnInit();
  }
  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
